import { render, staticRenderFns } from "./ProductDeleteItemModal.vue?vue&type=template&id=bb82191a&scoped=true"
import script from "./ProductDeleteItemModal.vue?vue&type=script&lang=js"
export * from "./ProductDeleteItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb82191a",
  null
  
)

export default component.exports